<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="modal-header">
  <h5 class="modal-title" [xdaTranslate]="'SDE_ALLOWED_DOMAINS'"></h5>
</div>
<div class="modal-body p-0" tabindex="-1">
  <table class="table">
    @for (domain of domains.split(','); track domain) {
      <tr>
        <td
          triggers="hover"
          [ngbTooltip]="domain"
          [disableTooltip]="domain.length < 32"
          [attr.aria-label]="domain">
          {{ domain.length > 32 ? (domain | slice: 0 : 32) + '...' : domain }}
        </td>
      </tr>
    }
  </table>
</div>
<div class="modal-footer">
  <div class="cb d-flex justify-content-end">
    <button
      type="button"
      class="xrx-btn btn-primary"
      (click)="activeModal.close()">
      <span class="btn-label" [xdaTranslate]="'SDE_CLOSE'"></span>
    </button>
  </div>
</div>
